<template>
  <section class="header">
    <h1
      class="site-heading py-5 text-uppercase text-white text-center d-none d-lg-block"
    >
      <span class="site-heading-upper mb-3">Web application made by</span>
      <span class="site-heading-lower">Fabio Costa</span>
    </h1>
  </section>
</template>

<script>
export default {
  name: "Header",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.site-heading {
  line-height: 1;
  margin-bottom: 0;
  margin-top: 0;

  &-upper {
    display: block;
    font-size: 2rem;
    font-weight: 800;
  }

  &-lower {
    font-size: 4rem;
    font-weight: 100;
    line-height: 4rem;
  }
}
</style>
